/**
 * header-cart.js
 * Handles: cart drawer open/close, AJAX add-to-cart listening (via a
 * custom 'premium:cart:add' event other theme code can dispatch),
 * quantity increase/decrease, line item removal, and live subtotal /
 * shipping-progress updates — all without a full page reload, using
 * Shopify's /cart.js and /cart/change.js endpoints.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-cart-sidebar]');

  function moneyFormat(cents) {
    return 'Rs' + (cents / 100).toFixed(2);
  }

  function refreshCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
      el.classList.remove('is-bumping');
      void el.offsetWidth;
      el.classList.add('is-bumping');
    });
    document.querySelectorAll('[data-cart-item-count]').forEach(function (el) {
      el.textContent = cart.item_count + ' Item(s)';
    });
  }

  function updateTotals(cart) {
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = moneyFormat(cart.total_price);
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = moneyFormat(cart.total_price);
    });

    var progressFill = document.querySelector('[data-shipping-progress]');
    var shippingBar = document.querySelector('[data-shipping-bar]');
    if (progressFill && shippingBar) {
      var threshold = parseFloat(shippingBar.dataset.threshold || '0') * 100;
      if (threshold > 0) {
        var percent = Math.min(100, (cart.total_price / threshold) * 100);
        progressFill.style.width = percent + '%';
      }
      shippingBar.hidden = cart.item_count === 0;
    }
  }

  function fetchCartAndUpdate() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        refreshCartCount(cart);
        updateTotals(cart);
        return cart;
      });
  }

  function reRenderCartSection() {
    // Re-fetches the header section markup so line items / empty state
    // reflect the latest cart contents without a full page reload.
    if (!root) return Promise.resolve();
    var sectionId = root.closest('header') ? root.closest('header').dataset.sectionId : null;
    if (!sectionId) return fetchCartAndUpdate();

    return fetch('/?section_id=' + sectionId)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newCartBody = doc.querySelector('[data-cart-body]');
        var newFooter = doc.querySelector('.cart-sidebar__footer');
        var currentBody = root.querySelector('[data-cart-body]');
        var currentFooter = root.querySelector('.cart-sidebar__footer');

        if (newCartBody && currentBody) {
          currentBody.innerHTML = newCartBody.innerHTML;
          bindCartBodyEvents();
        }
        if (currentFooter) {
          if (newFooter) {
            currentFooter.outerHTML = newFooter.outerHTML;
          } else {
            currentFooter.remove();
          }
        }

        return fetchCartAndUpdate();
      });
  }

  function changeLineItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return reRenderCartSection();
      });
  }

  function bindCartBodyEvents() {
    if (!root) return;

    root.querySelectorAll('[data-quantity-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('[data-quantity-wrapper]');
        var valueEl = wrapper.querySelector('[data-quantity-value]');
        var newQty = parseInt(valueEl.textContent, 10) + 1;
        valueEl.textContent = newQty;
        changeLineItem(wrapper.dataset.key, newQty);
      });
    });

    root.querySelectorAll('[data-quantity-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('[data-quantity-wrapper]');
        var valueEl = wrapper.querySelector('[data-quantity-value]');
        var newQty = Math.max(0, parseInt(valueEl.textContent, 10) - 1);
        valueEl.textContent = newQty;
        changeLineItem(wrapper.dataset.key, newQty);
      });
    });

    root.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLineItem(btn.dataset.key, 0);
      });
    });

    var noteField = root.querySelector('[data-cart-note]');
    if (noteField) {
      var noteTimer;
      noteField.addEventListener('input', function () {
        window.clearTimeout(noteTimer);
        noteTimer = window.setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: noteField.value })
          });
        }, 500);
      });
    }
  }

  bindCartBodyEvents();

  /* ---------------------------------------------------------------------
   * Listen for add-to-cart events from anywhere in the theme.
   * Other templates should: document.dispatchEvent(new CustomEvent('premium:cart:add', { detail: { id, quantity } }))
   * ------------------------------------------------------------------- */
  document.addEventListener('premium:cart:add', function (event) {
    var detail = event.detail || {};
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: detail.id, quantity: detail.quantity || 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return reRenderCartSection();
      })
      .then(function () {
        var toggle = document.querySelector('[data-cart-toggle]');
        var drawer = document.querySelector('[data-cart-sidebar]');
        window.PremiumHeader.openDrawer(drawer, toggle);
      });
  });

  /* ---------------------------------------------------------------------
   * Open / close wiring
   * ------------------------------------------------------------------- */
  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('aria-controls');
      var drawer = document.getElementById(targetId);
      window.PremiumHeader.openDrawer(drawer, btn);
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = btn.closest('[data-cart-sidebar]');
      window.PremiumHeader.closeDrawer(drawer);
    });
  });

  document.querySelectorAll('[data-cart-overlay]').forEach(function (overlay) {
    overlay.addEventListener('click', function () {
      var drawer = overlay.closest('[data-cart-sidebar]');
      window.PremiumHeader.closeDrawer(drawer);
    });
  });

})();
